'use strict';
module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/engine-user-agent.js
// module id = 975
// module chunks = 0